var _circle, _path, _line, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 66,
    viewBox: "0 0 264 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#478F96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2239 39V36.86H32.0639V26.94H31.8839L28.8439 30.54L27.2039 29.16L30.6639 25.04H34.6439V36.86H37.8439V39H28.2239Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 83.9896,
    y1: 32.5001,
    x2: 179.99,
    y2: 31.5001,
    stroke: "#478F96",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 231,
    cy: 33,
    r: 33,
    fill: "#478F96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.324 39H225.644V36.56L230.024 32.72C230.771 32.0667 231.317 31.48 231.664 30.96C232.011 30.4267 232.184 29.8533 232.184 29.24V28.98C232.184 28.3667 231.984 27.9 231.584 27.58C231.184 27.2467 230.697 27.08 230.124 27.08C229.404 27.08 228.857 27.2867 228.484 27.7C228.111 28.1 227.844 28.5867 227.684 29.16L225.404 28.28C225.551 27.8133 225.757 27.3733 226.024 26.96C226.291 26.5333 226.624 26.16 227.024 25.84C227.437 25.52 227.917 25.2667 228.464 25.08C229.011 24.8933 229.637 24.8 230.344 24.8C231.077 24.8 231.731 24.9067 232.304 25.12C232.877 25.32 233.357 25.6067 233.744 25.98C234.144 26.3533 234.444 26.7933 234.644 27.3C234.857 27.8067 234.964 28.36 234.964 28.96C234.964 29.5467 234.871 30.08 234.684 30.56C234.497 31.04 234.244 31.5 233.924 31.94C233.604 32.3667 233.231 32.78 232.804 33.18C232.377 33.5667 231.924 33.96 231.444 34.36L228.504 36.78H235.324V39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.b39b234bafd54beec998de1db7e69958.svg";
export { ForwardRef as ReactComponent };